import React, { useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { routePaths } from '../../../../routePaths';
import { FullScreenDialog } from '../../../../ui-kit';
import { InventoryCountComponent } from '../../../../generated/graphql';
import { useWarehousesScope } from '../../providers/WarehouseScopeProvider';
import InventoryCountDetailsView from './InventoryCountDetailsView';

const InventoryCountDetails = () => {
    const [isDialogOpened, setIsDialogOpened] = useState(true);
    const history = useHistory();
    const { params: { id: inventoryCountId } } = useRouteMatch();
    const { currentWarehouseId } = useWarehousesScope();

    const onClose = () => {
        setIsDialogOpened(false);
        history.push(routePaths.inventoryCounts);
    };

    return (
        <FullScreenDialog isOpened={isDialogOpened}>
            <InventoryCountComponent
                variables={{ id: inventoryCountId, warehouseId: currentWarehouseId as string }}
                redirectOnErrorUrl={routePaths.inventoryCounts}
            >
                {({ data: { inventoryCount } }) => {
                    return <InventoryCountDetailsView inventoryCount={inventoryCount} onClose={onClose} />;
                }}
            </InventoryCountComponent>
        </FullScreenDialog>
    );
};

export default InventoryCountDetails;